import PdfModal from 'components/PdfModal';
import { pdfModalTheme } from 'components/PdfModal/pdf-modal.config';
import { APP_COUNTRY, AR_CONTRACT_URL } from 'config';
import { selectInsertAccountNoteApiConfig } from 'pages/profile/profile.selectors';
import { useState } from 'react';
import { Translate } from 'react-localize-redux';
import { useStore } from 'react-redux';
import apiRequest from 'services/api/api.config';
import styled, { ThemeProvider } from 'styled-components';
import { useIsAtLeastDesktopBreakpoint } from 'utils/hooks/media-queries';
import { dispatchCustomEvent } from 'utils/hooks/use-custom-event';
import { useIsApp } from 'utils/hooks/useGetIsApp';
import OtpContractModal from './partials/OtpContractModal/OtpContractModal.component';
import { useDownloadContract } from './UserDownloadContractOnFooter.hooks';

export default function UserDownloadContractOnFooter() {
  /*------------------------------hooks------------------------------*/
  const { getState } = useStore();
  const [downloadContractModalVisible, setDownloadContractModalVisible] =
    useState(false);
  const [isOtpModalVisible, setIsOtpModalVisible] = useState(false);
  const downloadContract = useDownloadContract();
  const isApp = useIsApp();
  const isDesktop = useIsAtLeastDesktopBreakpoint();
  /*------------------------------config------------------------------*/
  const accountContractPdfUrl = AR_CONTRACT_URL;

  /*------------------------------helpers------------------------------*/
  const handleProceedButtonClick = () => {
    setIsOtpModalVisible(true);
    setDownloadContractModalVisible(false);
  };

  const insertSgadTrackingAccountNote = async () => {
    const { requestConfig } = selectInsertAccountNoteApiConfig(getState());
    await apiRequest.request(requestConfig);
  };

  const handleDownloadBtnClick = () => {
    //scarichiamo solo da desktop e se siamo da web in pratica
    if (isDesktop && !isApp) {
      window.open(accountContractPdfUrl, '_blank');
      return;
    }
    setDownloadContractModalVisible(true);
    //we use this inside the SlideInCompactMenu to close the drawer when we open the modal
    dispatchCustomEvent<boolean>('downloadContractModal', true);
  };

  const handleOtpSuccess = async () => {
    await downloadContract();
    setIsOtpModalVisible(false);
    await insertSgadTrackingAccountNote();
  };

  return (
    <>
      {APP_COUNTRY !== 'fr' && (
        <GamingAgreementCTA onClick={handleDownloadBtnClick}>
          <Translate id="lbl.gamingAgreement" />
        </GamingAgreementCTA>
      )}

      {downloadContractModalVisible ? (
        // For now, fallback to the blank contract
        <ThemeProvider theme={pdfModalTheme}>
          <PdfModal
            heading="lbl.profile.viewModal.heading"
            i18nHeading
            onClose={() => setDownloadContractModalVisible(false)}
            pdfUrl={AR_CONTRACT_URL}
          />
        </ThemeProvider>
      ) : isOtpModalVisible ? (
        <OtpContractModal
          heading="lbl.otp.modal.title"
          i18nHeading
          onClose={() => setIsOtpModalVisible(false)}
          onSuccess={handleOtpSuccess}
        />
      ) : null}
    </>
  );
}

const GamingAgreementCTA = styled.div`
  font-size: 14px;
  font-weight: 600;
  letter-spacing: -0.22px;
  line-height: 18px;
  text-decoration: underline;
  cursor: pointer;
`;
